import type { RefObject } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/components/ui/dialog";
import { AccessRequestForm } from "@/components/access-request-form";

const ACCESS_POINTS = [
  "Automated workload detection",
  "Evidence-based privacy reviews",
  "Automated artifact generation",
] as const;

export function AccessRequestModal({
  open,
  onOpenChange,
  triggerRef,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  triggerRef?: RefObject<HTMLButtonElement | null>;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        onCloseAutoFocus={(event) => {
          if (triggerRef?.current) {
            event.preventDefault();
            triggerRef.current.focus();
          }
        }}
      >
        <div className="grid gap-0 md:grid-cols-[0.9fr_1fr]">
          <div className="border-b border-border-subtle bg-surface px-6 py-8 md:border-r md:border-b-0 md:px-8 md:py-10">
            <p className="mb-4 font-mono text-[12px] font-medium uppercase tracking-[0.08em] text-primary">
              Request access
            </p>
            <DialogTitle className="text-[2rem] leading-[1.08] tracking-tight sm:text-[2.4rem]">
              See how privacy maps to your systems.
            </DialogTitle>
            <DialogDescription className="mt-4 text-base leading-relaxed">
              Truspecta is selectively onboarding organizations.
            </DialogDescription>
            <ul className="mt-7 space-y-3">
              {ACCESS_POINTS.map((point) => (
                <li key={point} className="flex gap-3 text-sm text-foreground-muted">
                  <span
                    aria-hidden="true"
                    className="mt-2 size-1.5 shrink-0 rounded-full bg-primary"
                  />
                  <span>{point}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="px-6 py-8 md:px-8 md:py-10">
            <AccessRequestForm />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
